import { Box, Typography } from '@mui/material'
import { getUnitDecimalPrecision } from 'features/measurementSystem/utils/selectableAbbreviations'
import { MoneyPerQuantityDto } from 'services/APIs/InternalAPI/internal-api.contracts'
import {
  DefinitiveMoneyField,
  DefinitiveMoneyFieldProps,
} from './DefinitiveMoneyField'
import {
  DefinitiveQuantityField,
  DefinitiveQuantityFieldProps,
} from './DefinitiveQuantityField'

type Props = Omit<
  DefinitiveMoneyFieldProps,
  'moneyDto' | 'onChange' | 'value' | 'validation'
> &
  Omit<
    DefinitiveQuantityFieldProps,
    'quantityDto' | 'onChange' | 'value' | 'validation'
  > & {
    value: MoneyPerQuantityDto
    onChange: (value: MoneyPerQuantityDto) => void
    label?: string
    validation?: (
      field: 'money' | 'quantity',
      value: MoneyPerQuantityDto,
    ) => string[]
  }

export const DefinitiveMoneyPerQuantityField = (props: Props) => {
  return (
    <Box
      className={props.rootElementClassName}
      sx={
        props.rootElementClassName
          ? null
          : {
              display: 'flex',
              alignItems: 'flex-end',
              gap: '.5em',
              '& label': {
                textOverflow: 'unset',
                overflow: 'visible',
              },
            }
      }
    >
      <div style={{ display: 'flex', alignItems: 'inherit', minWidth: '80px' }}>
        <DefinitiveMoneyField
          {...props}
          textFieldProps={{
            ...(props.textFieldProps || {}),
            label: props.label,
            name: 'money',
          }}
          onValidation={props.onValidation}
          validation={(money) => {
            return props.validation?.('money', {
              money,
              quantity: props.value.quantity,
            })
          }}
          moneyDto={props.value.money}
          onChange={(value) => {
            props.onChange({
              ...props.value,
              money: value,
            })
          }}
          disableWarningsIcon={props.disableWarningsIcon}
        />
      </div>
      <Typography color="GrayText" sx={{ margin: (t) => t.spacing(0, 1) }}>
        /
      </Typography>
      <DefinitiveQuantityField
        {...props}
        textFieldProps={{
          label: '',
          name: 'quantity',
          inputProps: {
            style: {
              width: 'auto',
              minWidth: 'unset',
              overflow: 'visible',
            },
          },
        }}
        validation={(quantity) => {
          return props.validation?.('quantity', {
            money: props.value.money,
            quantity,
          })
        }}
        numericFormatProps={{
          decimalScale: getUnitDecimalPrecision(props.value?.quantity?.unit, 0),
          allowNegative: false,
        }}
        quantityDto={props.value.quantity}
        onChange={(value) => {
          props.onChange({
            ...props.value,
            quantity: value,
          })
        }}
      />
    </Box>
  )
}
